import { render, staticRenderFns } from "./EntryRating.vue?vue&type=template&id=f167489c&scoped=true"
import script from "./EntryRating.vue?vue&type=script&lang=js"
export * from "./EntryRating.vue?vue&type=script&lang=js"
import style0 from "./EntryRating.vue?vue&type=style&index=0&id=f167489c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f167489c",
  null
  
)

export default component.exports